module.exports = __webpack_public_path__ + "static/media/WindHeat-thumbnail.606a1605.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ToolCard/thumbnails/WindHeat-thumbnail.png
// module id = 1222
// module chunks = 0